import React from "react";
import PropTypes from "prop-types";
import { Badge } from "reactstrap";
import { MasterSidebar } from "../../../../components/Common";
import { EVENT_TYPES, TEST_TYPES, getEventStatus } from "../constants";
import { GLOBAL_STATUS } from "../../../../constants/common";
import { GLOBAL_STATUS_LABELS } from "../../../../constants/common";;

/**
 * EventSidebar
 * Componente que renderiza a lista de Eventos no painel lateral do layout Master-Detail.
 */
const EventSidebar = ({
    events,
    activeId,
    onSelect,
    onCreateNew,
    loading
}) => {

    // Auxiliar para obter o nome do tipo de evento
    const getEventTypeName = (event) => {
        const typeVal = event?.type?.value || event?.type?.id || event?.type;
        const testTypeVal = event?.testType?.value || event?.testType?.id || event?.testType;

        const typeObj = EVENT_TYPES.find(t => t.value === typeVal);
        if (typeVal === "test" && testTypeVal) {
            const testObj = TEST_TYPES.find(t => t.value === testTypeVal);
            return `${typeObj?.label || "Evento"} - ${testObj?.label || "Desconhecido"}`;
        }
        return typeObj?.label || "Desconhecido";
    };

    // Função para renderizar cada item da lista
    const renderEventItem = (event, isActive) => {
        const typeVal = event?.type?.value || event?.type?.id || event?.type;
        
        return (
            <React.Fragment>
                <div className="d-flex align-items-center flex-grow-1 overflow-hidden">
                    <div className="avatar-xs flex-shrink-0 me-3">
                        <span className={`avatar-title rounded-circle bg-light ${isActive ? 'text-primary' : 'text-muted'}`}>
                             <i className={`mdi ${typeVal === 'test' ? 'mdi-arm-flex-outline' : 'mdi-clipboard-list-outline'}`}></i>
                        </span>
                    </div>
                    <div className="text-start overflow-hidden">
                        <h6 className={`mb-0 fw-semibold text-truncate font-size-14 ${isActive ? 'text-primary' : 'text-dark'}`}>
                            {event.name}
                        </h6>
                        <div className="d-flex align-items-center mt-1">
                            <span className="text-muted small text-truncate" style={{ fontSize: '11px', opacity: 0.8 }}>
                                {getEventTypeName(event)}
                            </span>
                        </div>
                    </div>
                </div>

                <div className="ms-2 flex-shrink-0">
                    <Badge
                        color={getEventStatus(event) === GLOBAL_STATUS.ACTIVE ? 'success' : 'danger'}
                        className={`font-size-10 px-2 flex-shrink-0 bg-opacity-10 text-${getEventStatus(event) === GLOBAL_STATUS.ACTIVE ? 'success' : 'danger'}`}
                        style={{ backgroundColor: 'transparent' }}
                    >
                        {GLOBAL_STATUS_LABELS[getEventStatus(event)] || 'Desconhecido'}
                    </Badge>
                </div>
            </React.Fragment>
        );
    };

    return (
        <MasterSidebar
            title="Eventos"
            subtitle={`${events?.length || 0} cadastrados`}
            items={events}
            activeId={activeId}
            onSelect={onSelect}
            onCreateNew={onCreateNew}
            loading={loading}
            searchPlaceholder="Buscar evento..."
            icon="mdi mdi-calendar-star"
            renderItem={renderEventItem}
            loadingMessage="Carregando avaliações e eventos..."
        />
    );
};

EventSidebar.propTypes = {
    events: PropTypes.array.isRequired,
    activeId: PropTypes.string,
    onSelect: PropTypes.func.isRequired,
    onCreateNew: PropTypes.func.isRequired,
    loading: PropTypes.bool
};

export default EventSidebar;
